// Display helpers for quotation line items — show values in the unit chosen at entry.
const trim = (n, d = 4) => Number(Number(n || 0).toFixed(d));

export const thkDisplay = (it) => it.thickness_label || `${it.thickness} mm`;

export const lenDisplay = (it) =>
  it.length_unit === "m" ? `${trim(it.length_ft * 0.3048)} m` : `${trim(it.length_ft)} ft`;

export const qtyDisplay = (it) =>
  it.length_unit === "m" ? `${trim(it.qty * it.length_ft * 0.3048, 2)} m` : `${trim(it.qty, 3)}`;
